import { useMemo } from 'react';

import usePlaceholderResume from '@glass/shared/modules/resumes/hooks/usePlaceholderResume';
import mergePlaceholderResume from '@glass/shared/modules/resumes/mergePlaceholderResume';

const useMergePlaceholderResume = ({ resume, iSlug, jSlug, seedOverride, skip }) => {
  const { placeholderResume, loading, error } = usePlaceholderResume({
    iSlugParam: iSlug,
    jSlugParam: jSlug,
    seedOverrideParam: seedOverride,
    skip,
  });
  const { resume: mergedResume, sectionClasses } = useMemo(
    () => mergePlaceholderResume(resume, placeholderResume),
    [resume, placeholderResume],
  );
  return {
    resume: mergedResume,
    sectionClasses,
    placeholderResume,
    loading,
    error,
  };
};

export default useMergePlaceholderResume;
